var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-select',{class:_vm.klass,attrs:{"value":_vm.value,"mode":_vm.mode,"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"change":_vm.onChange}},_vm._l((_vm.list),function(item){return _c('a-select-option',{key:item.key,attrs:{"value":item.value}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9aca104","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/select/DynamicSelect.vue
// module id = null
// module chunks = 